import React, { useEffect, useState, memo } from 'react'
import {
  Typography, Box, FormControlLabel, Checkbox, Grid, Stack
} from '@mui/material'
import stylesheet from '../detail/detail-container.stylesheet'
import helper from '../../../utils/helper'
import { ClassNameMap, withStyles } from '@mui/styles'
import { RootState, useAppThunkDispatch } from '../../../redux/store'
import { useSelector } from 'react-redux'
import { setPatientsTable } from '../../../redux/common-data-slice'
import IpatientsTable from '../../../model/patientTable'
interface IProps {
  name: string
  input: any
  stateKey: string
  filterCount: any
  classes: ClassNameMap
}

const FilterChunkComponent: React.FC<IProps> = ({
  name,
  input,
  stateKey,
  filterCount,
  classes,
}) => {
  const [data, setData] = useState(input)
  const dispatch = useAppThunkDispatch()
  const patientsTable = useSelector((state: RootState) => state.commonData.patientsTable)
  const hospitalsData = useSelector((state: RootState) => state.metaData.metadata.HOSPITALS)

  useEffect(() => {
    const temp = (patientsTable[stateKey as keyof IpatientsTable] || '').toString()

    setData(
      input?.map((m: any) =>
        (temp.split(',').includes(m.value))
          ? { ...m, checked: true }
          : { ...m, checked: false }
      )
    )
  }, [input, patientsTable])

  const optionChanged = (_key: string, _value: string) => {
    const temp = data?.map((e: any) => e.value === _value ? { ...e, checked: !e.checked } : { ...e })
    if (_key === 'Hospitals') {
      const hospitalFilter = temp.filter((i: any) => i.checked)?.map((i: any) => i.name)
      localStorage.setItem("atman-hospitals", (hospitalFilter)?.join(','))
    }
    dispatch(
      setPatientsTable({
        ...patientsTable,
        isSubmit: 'reset',
        page: 1,
        limit: 50,
        [stateKey]: temp
          ?.filter((e: { checked: boolean }) => e.checked === true)
          ?.map((m: { value: any }) => m.value)
          .join(),
      })
    )
    setData(temp)
  }

  const getKeyName = (name: any, key: any) => (stateKey === 'hospitals')
    ? (hospitalsData && hospitalsData.hasOwnProperty(name)
      ? hospitalsData[name]
      : helper.stageName(name) || [])
    : helper.stageName(name)

  return (
    <Box pb={0.8} className={name === 'Hospitals' ? classes.filterBorderBottom : classes.filterChunkContainer}>
      <Grid container direction="row" justifyContent="space-between" alignItems={'center'} sx={{ height: '1.2rem' }}>
        <Grid item>
          <Typography className={classes.desc} variant="body2"><strong>{name}</strong></Typography>
        </Grid>
      </Grid>
      {data?.map((e: any, i: number) => (
        <Stack key={i} direction='row' justifyContent="space-between" alignItems={'center'} className={classes.filterChunkItems}>
          {name !== 'Patients with' ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  onChange={() => optionChanged(name, e.value)}
                  sx={{
                    transform: "scale(0.6) !important",
                    height: '1rem',
                    padding: '0px 0px 0px 5px !important',
                    color: e.color || 'default',
                  }}
                  className={classes.checkBoxStyle}
                  checked={e.checked}
                  name="checkedA"
                  size="small"
                />
              }
              label={
                <Typography className={classes.desc} variant="body2">
                  {e.checked === true
                    ? <strong>{getKeyName(e.name, stateKey)}</strong>
                    : e?.name && stateKey && getKeyName(e.name, stateKey)
                  }
                </Typography>
              }
            />
          ) : (
            <Typography className={classes.desc} variant="body2">{helper.stageName(e.name)}</Typography>
          )}
          <Box className={classes.whiteSpaceNowrap}>
            <Typography className={classes.desc} variant="body2">
              <small>{(filterCount?.[e.value] || filterCount?.[e.name]) ?? 'NA'}</small>
            </Typography>
          </Box>
        </Stack>
      ))}
    </Box>
  )
}

export default memo(withStyles(stylesheet)(FilterChunkComponent))
